import { environment } from "@environment";
import mixpanel from "mixpanel-browser";

mixpanel.init(environment.mixpanel, {
  persistence: "localStorage",
  debug: environment.env !== "production",
  record_idle_timeout_ms: 1800000,
  record_sessions_percent: 1,
  record_mask_text_selector: "",
  ignore_dnt: true,
});

window.mixpanel = mixpanel;
export const mixpanelClient = mixpanel;
